/**
 * list of all supported locales, in order
 * 
 * code may be `fr-ca`, `en-us` or just `en`
 * but we use `name` for route's names
 **/

import { find, keyBy, mapValues } from 'lodash';

// export type Locale = {
//   id: number, // api siteId
//   name: string, // vue routes names `home.fr`
//   uri: string, // for url `/fr_ca/contact` - if no defined simply use name
//   code: string // for html lang `lang="fr_CA"` - if no defined simply use name
// }

type SimpleLocale = {
  id: number,
  name: string,
  /* url portion (en | en-CA) */
  uri?: string,
  /* iso code - maybe not used in url - fr-CA */
  code?: string,
  env: string, // map current domain by locale, 
  i18n: string, // map to i18n locale (in case we have 4 different website FR without the need to have 4 different i18n files)
  main: boolean,
}

const _locales:SimpleLocale[] = [{
  id: 1,
  name: 'fr',
  uri: '/fr/',
  code: 'fr-CA',
  env: 'VITE_SITE_URL_FR',
  i18n: 'fr',
  main: true,
}]

// export locales with defaults values
export const locales:Koddein.Locale[] = _locales.map(({id, name, uri, code, env, i18n, main})=>({
  id,
  name,
  uri:uri || name,
  code:code || name,
  env,
  i18n,
  main
}))

export const localesByUri = keyBy(locales, 'uri')
export const localesBySiteId = keyBy(locales, 'id')
export const urisBySiteId = mapValues(localesBySiteId, ({uri})=>uri)
export const uris = mapValues(localesBySiteId, ({uri})=>uri)

// @todo default locale
// export const locale = locales[0]

export function byName(name:string):Optional<Koddein.Locale>{ return find(locales, (locale:Koddein.Locale)=>name===locale.name) }
export function byCode(code:string):Optional<Koddein.Locale>{ return find(locales, (locale:Koddein.Locale)=>code===locale.code) }
export function byUri(uri:string):Optional<Koddein.Locale>{ return find(locales, (locale:Koddein.Locale)=>uri===locale.uri) }
export function byId(id:number):Optional<Koddein.Locale>{ return find(locales, (locale:Koddein.Locale)=>id===locale.id) }

export default locales
